module.exports = __webpack_public_path__ + "__static/site-1783523783704/img/lion.37aaaa62.png";